import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class CentrosCustosService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  get() {
    return this.http.get(this.UrlService + 'CentrosCustos')
      .pipe(map(super.extractData)
        , catchError(super.serviceError))
  }

  getPaginado(pagina: number, nome: string) {
    return this.http
      .get(this.UrlService + `CentrosCustos/Paginado?pageIndex=` + pagina + '&search=' + encodeURIComponent(nome))
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  post(form) {
    return this.http.post(this.UrlService + 'CentrosCustos', form)
      .pipe(map(super.extractData)
        , catchError(super.serviceError))
  }

  getCentroCustoById(id: number) {
    return this.http
      .get(this.UrlService + "CentrosCustos/" + id)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  delete(id: number) {
    return this.http.delete(this.UrlService + `CentrosCustos/${id}`)
      .pipe(map(super.extractData)
        , catchError(super.serviceError));
  }
}
